<template>
  <div>
    <!--  -->
    <v-card elevation="0" class="pa-2">
      <vue-table
        :data="transactionData"
        :headers="headers"
        :loading.sync="loading"
        :props.sync="tableProps"
      >
        <!-- @change="onPagination" -->
        <template v-slot:filters="{ props }">
          <v-row>
            <v-col cols="12" md="6" lg="3">
              <v-combobox
                :items="page"
                :label="`تعداد نمایش`"
                append-icon="mdi-chevron-down"
                dense
                outlined
                v-model="props.length"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <v-combobox
                :items="services"
                :label="`سرویس`"
                append-icon="mdi-chevron-down"
                dense
                outlined
              ></v-combobox>
            </v-col>
            <!-- <v-col cols="12" md="6" lg="3">
              <date-picker
                v-model="time.start_time"
                clearable
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                label="از تاریخ"
              />
            </v-col> -->
            <!-- <v-col cols="12" md="6" lg="3">
              <date-picker
                v-model="time.end_time"
                clearable
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                label="تا تاریخ"
              />
            </v-col> -->
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{
            transactionData.data.findIndex((data) => data.index == item.index) +
            1
          }}
        </template>
        <template v-slot:qr="{ item }">
          {{ item.qr }}
        </template>
        <template v-slot:price="{ item }">
          <v-btn
            color="#f28b82
"
            class="white--text"
            elevation="0"
            width="100px"
          >
            {{ item.price.toLocaleString() }}
          </v-btn>
        </template>
        <template v-slot:type="{ item }">
          <v-btn
            color="#a0c8e8"
            class="white--text"
            flt
            elevation="0"
            width="100px"
            >{{ showType(item.type) }}</v-btn
          >
        </template>
        <template v-slot:time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:description="{ item }">
          {{ item.description }}
        </template>
      </vue-table>
    </v-card>
    <!--  -->
  </div>
</template>

<script>
import selectGateSlaes from "../components/gate/selectGateSlaes.vue";

// داده دارد
export default {
  components: { selectGateSlaes },

  props: {
    loadingPage: Boolean,
    info: Array,
  },
  data() {
    return {
      page: ["10", "20", "30", "40", "50"],
      selected: [], // برای ذخیره ردیف‌های انتخاب‌شده
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center" }, // ستون جدید برای شماره ردیف
        { value: "qr", text: "نام کیوآر", sortable: true, align: "center" },
        { value: "type", text: "سرویس", sortable: true, align: "center" },
        {
          value: "price",
          text: "مبلغ (تومان)",
          sortable: true,
          align: "center",
        },
        {
          value: "time",
          text: "زمان پرداخت",
          sortable: false,
          align: "center",
        },
        {
          value: "description",
          text: "توضیحات",
          sortable: false,
          align: "center",
        },
      ],
      transactionData: {
        data: [
          {
            index: 1,
            qr: "سوپرمارکت احسان",
            type: "rent",
            price: 120000,
            time: "1404/04/25",
            description: "پرداخت اجاره ماه تیر",
          },
          {
            index: 2,
            qr: "کافه گلدون",
            type: "charge",
            price: 30000,
            time: "1404/04/28",
            description: "هزینه شارژ ماهیانه",
          },
          {
            index: 3,
            qr: "لباس فروشی پانیذ",
            type: "banner",
            price: 50000,
            time: "1404/05/01",
            description: "تبلیغ در صفحه اول",
          },
          {
            index: 4,
            qr: "فروشگاه دیجیتال رایان",
            type: "space",
            price: 250000,
            time: "1404/05/03",
            description: "اجاره فضای اختصاصی",
          },
          {
            index: 5,
            qr: "کتاب‌فروشی نادر",
            type: "rent",
            price: 145000,
            time: "1404/05/06",
            description: "پرداخت اجاره مرداد",
          },
        ],
        total: 5,
        page: 1,
        per_page: 10,
      },
      tableProps: {
        search: "",
        length: 10,
        productId: [],
        column: "id",
        dir: "desc",
        page: 1,
      },
      services: [
        { value: "rent", text: "اجاره" },
        { value: "charge", text: "شارژ" },
        { value: "banner", text: "رزرو بنر" },
        { value: "space", text: "رزرو فضا" },
      ],
      time: {
        start_time: "",
        end_time: "",
      },

      // داده‌های نمونه
    };
  },
  methods: {
    getPersianDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "تاریخ نامعتبر";
      const formatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return formatter.format(date);
    },
    showType(e) {
      switch (e) {
        case "rent":
          return "اجاره";
        case "charge":
          return "شارژ";
        case "banner":
          return "اجاره بنر";
        case "space":
          return "اجاره فضای تبلیغاتی";
      }
    },
  },
};
</script>

<style scoped>
/* استایل‌های اضافی برای جدول */
.elevation-1 {
  margin: 20px;
}
</style>
